"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviterIdentifierType = void 0;
var InviterIdentifierType;
(function (InviterIdentifierType) {
    InviterIdentifierType["Email"] = "email";
    InviterIdentifierType["Uuid"] = "uuid";
})(InviterIdentifierType || (exports.InviterIdentifierType = InviterIdentifierType = {}));
